import { LOADING_OVERLAY_Z_INDEX } from '@constants/z-indices';
import clsx from 'clsx';
import { AnimatePresence, motion } from 'motion/react';

import { Spinner } from './Spinner';

export interface LoadingOverlayProps {
  active?: boolean;
  className?: string;
  onClick?: any;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  unmount?: boolean;
  transparent?: boolean;
}

const LoadingOverlay = ({
  active = false,
  className,
  size,
  transparent = false,
  unmount = false,
  ...props
}: LoadingOverlayProps) => {
  return (
    <AnimatePresence mode={unmount ? 'wait' : 'sync'}>
      {active && (
        <motion.div
          data-testid="loading-overlay"
          onClick={props.onClick}
          onKeyDown={() => {}}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
          className={clsx(
            'absolute',
            'inset-0',
            LOADING_OVERLAY_Z_INDEX,
            'h-full',
            'w-full',
            'text-clip',
            'select-none',
            'flex',
            'items-center',
            'justify-center',
            !transparent && 'bg-black/50 text-white',
            className,
          )}
        >
          <Spinner size={size} />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
export default LoadingOverlay;
